import {
    CREATE_USER_PRODUCT_MEMBERSHIP_POOL,
    CREATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
    DELETE_USER_PRODUCT_MEMBERSHIP_POOL,
    DELETE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
    DELETE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOL,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOLS,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_FAILURE,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_SUCCESS,
    SORT_DESC,
    UPDATE_USER_PRODUCT_MEMBERSHIP_POOL,
    UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
} from 'store/actions/types';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';
import { omit, size } from 'lodash';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_DESC,
    page: 1,
    size: 24,
    total: 0,
};

export default (state = initialState,
    action) => {
    switch (action.type) {

        case FETCH_USER_PRODUCT_MEMBERSHIP_POOLS:
        case FETCH_USER_PRODUCT_MEMBERSHIP_POOL:
        case CREATE_USER_PRODUCT_MEMBERSHIP_POOL:
        case DELETE_USER_PRODUCT_MEMBERSHIP_POOL:
        case UPDATE_USER_PRODUCT_MEMBERSHIP_POOL:
            return {
                ...state,
                loading: true,
            };
        case FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_SUCCESS: {
            const { results, ...response } = action.payload;
            const responseData = utils.mapToObject(results, (value) => {
                return value.id;
            });

            const data = { ...state.data, ...responseData };

            return {
                ...state,
                ...response,
                loading: false,
                data,
                ids: Object.keys(data),
            };
        }
        case FETCH_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS: {
            const data = {
                ...state.data,
                [action.payload.id]: action.payload,
            };

            return {
                ...state,
                loading: false,
                data,
                total: size(data),
                ids: Object.keys(data),
            };
        }
        case DELETE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS: {
            const data = omit(state.data, action.payload.id);

            return {
                ...state,
                loading: false,
                data,
                total: state.total ? state.total - 1 : state.total,
                size: state.size ? state.size - 1 : state.size,
                ids: Object.keys(data),
            };
        }
        case FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_FAILURE:
        case FETCH_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE:
        case CREATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE:
        case DELETE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE:
        case UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/userProductMembershipPoolReducer.js